import React from "react";

export default function PrimaryButton({ children, className = "", type = "button", disabled, onClick, ...rest }) {
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={[
        "w-full h-14 rounded-xl bg-[#00357C] text-white font-semibold",
        "shadow-sm hover:bg-[#002766] active:scale-[0.99] transition-all",
        "disabled:bg-slate-300 disabled:text-slate-500 disabled:cursor-not-allowed",
        "flex items-center justify-center gap-2 text-base",
        className,
      ].join(" ")}
      {...rest}
    >
      {children}
    </button>
  );
}

export function GhostButton({ children, className = "", ...rest }) {
  return (
    <button
      className={[
        "w-full h-12 rounded-xl border border-slate-200 bg-white text-slate-700 font-medium",
        "hover:bg-slate-50 active:scale-[0.99] transition-all flex items-center justify-center gap-2",
        className,
      ].join(" ")}
      {...rest}
    >
      {children}
    </button>
  );
}
